import React, { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Swal from "sweetalert2";
import { CartContext } from "../context/CartContext";

const Categorias = () => {
  const { dbCategories, loadCategories } = useContext(CartContext);
  const [show, setShow] = useState(false);
  const [nuevaCategoria, setNuevaCategoria] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // --- FUNCIÓN AGREGAR ---
  const handleCreate = async () => {
    if (!nuevaCategoria.trim()) return;
    try {
      const resp = await fetch(
        "https://optimarketok.com.ar/api/manage_categories.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            action: "add",
            nombre: nuevaCategoria.trim(),
          }),
        },
      );
      const res = await resp.json();
      if (res.success) {
        setNuevaCategoria("");
        loadCategories(); // Refresca el context global
        Swal.fire({
          title: "Creada",
          icon: "success",
          timer: 1000,
          showConfirmButton: false,
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  // --- FUNCIÓN ELIMINAR ---
  const handleDelete = async (id) => {
    Swal.fire({
      title: "¿Eliminar categoría?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await fetch("https://optimarketok.com.ar/api/manage_categories.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "delete", id }),
        });
        loadCategories();
        Swal.fire("Eliminada", "", "success");
      }
    });
  };

  return (
    <>
      <div className="boton" onClick={handleShow}>
        Categorias
      </div>

      <Modal show={show} onHide={handleClose} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Gestión de Categorías</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            {/* Listado de categorías existentes */}
            {dbCategories.map((cat) => (
              <div className="d-flex mb-2 align-items-center" key={cat.id}>
                <input
                  type="text"
                  className="form-control ps-2"
                  value={cat.nombre}
                  readOnly // En MySQL el update de nombre es más delicado por los productos asociados
                />
                <div
                  className="btnCat ms-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(cat.id)}
                >
                  <i className="btnCant bi bi-trash3 text-danger"></i>
                </div>
              </div>
            ))}

            <hr />

            {/* Nueva categoría */}
            <div className="d-flex mt-3">
              <input
                type="text"
                className="form-control ps-2"
                value={nuevaCategoria}
                placeholder="Nombre de nueva categoría"
                onChange={(e) => setNuevaCategoria(e.target.value)}
              />
              <div
                className="btnCant ms-2"
                onClick={handleCreate}
                style={{ cursor: "pointer" }}
              >
                <i className="bi bi-check-square-fill text-success fs-4"></i>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Categorias;
